
import authRoutes from "./auth.routes";
import callCenterRoutes from "./call.center.routes";
import trainingRoutes from "./training.routes";
import dashboardRoutes from "./dashboard.routes";
import miscRoutes from "./misc.routes";
import settingsRoutes from "./settings.routes";
import onboardingRoutes from "./onboarding.routes";
import leadRoutes from "./leads.routes";
import dealsRoutes from "./deals.routes";
import funnelRoutes from "./funnels.routes";
import meetingSchedulerRoutes from "./meeting.sheculder.routes";
import tasksRoutes from "./tasks.routes";
import calendarRoutes from "./calendar.routes";
import Error404 from "@/components/404";

const routes = [
  ...authRoutes,
  ...dashboardRoutes,
  ...callCenterRoutes,
  ...trainingRoutes,
  ...miscRoutes,
  ...settingsRoutes,
  ...onboardingRoutes,
  ...leadRoutes,
  ...dealsRoutes,
  ...funnelRoutes,
  ...meetingSchedulerRoutes,
  ...tasksRoutes,
  ...calendarRoutes,
  ...trainingRoutes,
  { path: "*", element: <Error404 /> },
];

export default routes;